
import UMUM from "../../library/umum";

export default {
  data() {
    return {
      form: {
        id: "",
        tahun: "",
        indikator: "",
        jenjang: "",
        sekolah: "",
        kecamatan: "",
        a: 0,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 0,
        g: 0,
        h: 0,
        keterangan: "",
        createAt: "",
        editedAt: "",
      },

      tahun: "",
      sumber: "",
      kendala: "",
      total1: "",
      total2: "",
      total3: "",
      total4: "",
      total5: "",
      total6: "",
      total7: "",
      total8: "",
      indikator: "",
      nama_tahun: "",
      nama_kadis: "",
      nip_kadis: "",
      pangkat_kadis: "",
      gol_kadis: "",
      ruang_kadis: "",
      gel_bel_kadis: "",
      gel_dep_kadis: "",

      list_data: [],
      cetak_data: [],
      list_tahun: [],
      list_kecamatan: [],
      list_indikator: [],

      page_first: 1,
      page_last: 0,
      cari_value: "",
      cek_load_data: true,

      mdl_add: false,
      mdl_cetak: false,
      mdl_print: false,
      mdl_download: false,
      mdl_edit: false,
      mdl_hapus: false,
      btn_add: false,

      UMUM: UMUM,
    };
  },
  computed: {
    subTotalCols() {
      const cols = this.indikatorSchema.table.bodyColumns;
      const rows = this.normalizedCetakRows;

      const totals = {};

      cols.forEach((c) => (totals[c] = 0));

      rows.forEach((r) => {
        cols.forEach((c) => {
          totals[c] += Number(r[c] || 0);
        });
      });

      return totals;
    },

    grandTotal() {
      const cols =
        this.indikatorSchema.table.sumColumns ||
        this.indikatorSchema.table.bodyColumns;
      return cols.reduce(
        (sum, c) => sum + Number(this.subTotalCols[c] || 0),
        0,
      );
    },
    indikatorSchema() {
      const id = Number(this.form?.indikator?.id);

      // helper cepat
      const num = (v) => Number(v || 0);

      const isCetak = this.mdl_cetak;

      // =========================
      // INDIKATOR 1
      // =========================
      if (id === 1) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 3, width: "5%" },
                { label: "Kecamatan", rowspan: 3, width: "12%" },
                {
                  label:
                    "Jumlah Siswa Usia 5 s.d. 6 Tahun Sedang Belajar di Satuan Pendidikan Anak Usia Dini",
                  colspan: 4,
                },
                { label: "Total", rowspan: 3, width: "8%" },
                { label: "Ket", rowspan: 3, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 3, width: "7%" }] : []),
              ],
              [
                { label: "Penduduk Kabupaten/Kota Bersangkutan", colspan: 2 },
                { label: "Bukan Penduduk Kabupaten/Kota", colspan: 2 },
              ],
              [
                { label: "TK" },
                { label: "RA" },
                { label: "TK" },
                { label: "RA" },
              ],
            ],

            bodyColumns: ["a", "b", "c", "d"],
            sumColumns: ["a", "b", "c", "d"],
            showTotal: true,
            showSubTotal: true,
            showGrandTotal: true,
            showKet: true,
            showAksi: !isCetak,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                title: "Penduduk Kabupaten/Kota Bersangkutan",
                cols: 2,
                fields: [
                  { key: "a", label: "TK", type: "number" },
                  { key: "b", label: "RA", type: "number" },
                ],
              },
              {
                title: "Bukan Penduduk Kabupaten/Kota",
                cols: 2,
                fields: [
                  { key: "c", label: "TK", type: "number" },
                  { key: "d", label: "RA", type: "number" },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const c = num(row.c);
            const d = num(row.d);

            return {
              ...row,
              a,
              b,
              c,
              d,
              total: a + b + c + d,
            };
          },
        };
      }
      // =========================
      // INDIKATOR 2
      // =========================
      if (id === 2) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Kecamatan", rowspan: 2, width: "12%" },
                {
                  label: "Usia Anak 5 s.d. 6 Tahun",
                  colspan: 3,
                },
                { label: "Ket", rowspan: 2, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [
                { label: "Laki-laki" },
                { label: "Perempuan" },
                { label: "Jumlah" },
              ],
            ],

            bodyColumns: ["a", "b", "total"],
            sumColumns: ["a", "b"],
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                title: "Usia Anak 5 s.d. 6 Tahun",
                cols: 2,
                fields: [
                  { key: "a", label: "Laki-laki", type: "number" },
                  { key: "b", label: "Perempuan", type: "number" },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);

            return {
              ...row,
              a,
              b,
              total: a + b,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 3
      // =========================
      if (id === 3) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 3, width: "5%" },
                { label: "Kecamatan", rowspan: 3, width: "12%" },
                {
                  label: "Penduduk Kabupaten/Kota yang bersangkutan",
                  colspan: 4,
                },
                {
                  label:
                    "Bukan Penduduk Kabupaten/Kota yang bersekolah di wilayahnya",
                  colspan: 4,
                },
                { label: "Total", rowspan: 3, width: "8%" },
                ...(!isCetak ? [{ label: "", rowspan: 3, width: "7%" }] : []),
              ],
              [
                { label: "Usia 7 s.d. 12 Tahun", colspan: 2 },
                { label: "Usia 13 s.d. 15 Tahun", colspan: 2 },
                { label: "Usia 7 s.d. 12 Tahun", colspan: 2 },
                { label: "Usia 13 s.d. 15 Tahun", colspan: 2 },
              ],
              [
                { label: "SD" },
                { label: "Madrasah Ibtidayah" },
                { label: "SMP" },
                { label: "Madrasah Tsanawiyah" },
                { label: "SD" },
                { label: "Madrasah Ibtidayah" },
                { label: "SMP" },
                { label: "Madrasah Tsanawiyah" },
              ],
            ],

            bodyColumns: ["a", "b", "c", "d", "e", "f", "g", "h"],
            sumColumns: ["a", "b", "c", "d", "e", "f", "g", "h"],
            showTotal: true,
            showKet: false,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: true,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                title: "Penduduk Kabupaten/Kota yang bersangkutan",
                cols: 12,
                subGroups: [
                  {
                    title: "Usia 7 s.d. 12 Tahun",
                    cols: 6,
                    fields: [
                      { key: "a", label: "SD", type: "number" },
                      { key: "b", label: "MI", type: "number" },
                    ],
                  },
                  {
                    title: "Usia 13 s.d. 15 Tahun",
                    cols: 6,
                    fields: [
                      { key: "c", label: "SMP", type: "number" },
                      { key: "d", label: "MTs", type: "number" },
                    ],
                  },
                ],
              },
              {
                title:
                  "Bukan Penduduk Kabupaten/Kota yang bersekolah di wilayahnya",
                cols: 12,
                subGroups: [
                  {
                    title: "Usia 7 s.d. 12 Tahun",
                    cols: 6,
                    fields: [
                      { key: "e", label: "SD", type: "number" },
                      { key: "f", label: "MI", type: "number" },
                    ],
                  },
                  {
                    title: "Usia 13 s.d. 15 Tahun",
                    cols: 6,
                    fields: [
                      { key: "g", label: "SMP", type: "number" },
                      { key: "h", label: "MTs", type: "number" },
                    ],
                  },
                ],
              },
            ],
            showKet: false,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const c = num(row.c);
            const d = num(row.d);
            const e = num(row.e);
            const f = num(row.f);
            const g = num(row.g);
            const h = num(row.h);

            return {
              ...row,
              a,
              b,
              c,
              d,
              e,
              f,
              g,
              h,
              total: a + b + c + d + e + f + g + h,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 4
      // =========================
      if (id === 4) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 3, width: "5%" },
                { label: "Kecamatan", rowspan: 3, width: "12%" },
                { label: "Usia Anak", colspan: 6 },
                { label: "Ket", rowspan: 3, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 3, width: "7%" }] : []),
              ],
              [
                { label: "Usia 7 s.d. 12 Tahun", colspan: 3 },
                { label: "Usia 13 s.d. 15 Tahun", colspan: 3 },
              ],
              [
                { label: "Laki-laki" },
                { label: "Perempuan" },
                { label: "Jumlah" },
                { label: "Laki-laki" },
                { label: "Perempuan" },
                { label: "Jumlah" },
              ],
            ],

            bodyColumns: ["a", "b", "total1", "c", "d", "total2"],
            sumColumns: ["a", "b", "c", "d"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: true,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                title: "Usia Anak",
                cols: 12,
                subGroups: [
                  {
                    title: "Usia 7 s.d. 12 Tahun",
                    cols: 6,
                    fields: [
                      { key: "a", label: "Laki-laki", type: "number" },
                      { key: "b", label: "Perempuan", type: "number" },
                    ],
                  },
                  {
                    title: "Usia 13 s.d. 15 Tahun",
                    cols: 6,
                    fields: [
                      { key: "c", label: "Laki-laki", type: "number" },
                      { key: "d", label: "Perempuan", type: "number" },
                    ],
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const c = num(row.c);
            const d = num(row.d);

            return {
              ...row,
              a,
              b,
              c,
              d,
              total1: a + b,
              total2: c + d,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 5
      // =========================
      if (id === 5) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 3, width: "5%" },
                { label: "Kecamatan", rowspan: 3, width: "12%" },
                {
                  label:
                    "Jumlah Siswa Usia 7 s.d. 18 Tahun Berpartisipasi Pendidikan Kesetaraan",
                  colspan: 8,
                },
                { label: "Ket", rowspan: 3, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 3, width: "7%" }] : []),
              ],
              [
                { label: "Penduduk Kabupaten/Kota Bersangkutan", colspan: 4 },
                { label: "Bukan Penduduk Kabupaten/Kota", colspan: 4 },
              ],
              [
                { label: "Paket A" },
                { label: "Paket B" },
                { label: "Paket C" },
                { label: "Jumlah" },
                { label: "Paket A" },
                { label: "Paket B" },
                { label: "Paket C" },
                { label: "Jumlah" },
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["a", "b", "c", "jumlah1", "d", "e", "f", "jumlah2"],
            sumColumns: ["a", "b", "c", "d", "e", "f"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: true,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                title: "Penduduk Kabupaten/Kota Bersangkutan",
                cols: 6,
                fields: [
                  { key: "a", label: "Paket A", type: "number" },
                  { key: "b", label: "Paket B", type: "number" },
                  { key: "c", label: "Paket C", type: "number" },
                ],
              },
              {
                title: "Bukan Penduduk Kabupaten/Kota",
                cols: 6,
                fields: [
                  { key: "d", label: "Paket A", type: "number" },
                  { key: "e", label: "Paket B", type: "number" },
                  { key: "f", label: "Paket C", type: "number" },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const c = num(row.c);
            const d = num(row.d);
            const e = num(row.e);
            const f = num(row.f);

            return {
              ...row,
              a,
              b,
              c,
              d,
              e,
              f,
              jumlah1: a + b + c,
              jumlah2: d + e + f,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 6
      // =========================
      if (id === 6) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 3, width: "5%" },
                { label: "Kecamatan", rowspan: 3, width: "12%" },
                {
                  label:
                    "Jumlah Penduduk Usia 7 s.d. 18 Tahun yang Belum Menyelesaikan Pendidikan Dasar dan Menengah",
                  colspan: 6,
                },
                { label: "Jumlah", rowspan: 3, width: "15%" },
                { label: "Ket", rowspan: 3, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 3, width: "7%" }] : []),
              ],
              [
                { label: "7 s.d. 12 Tahun", colspan: 2 },
                { label: "13 s.d. 15 Tahun", colspan: 2 },
                { label: "16 s.d. 18 Tahun", colspan: 2 },
              ],
              [
                { label: "Laki-laki" },
                { label: "Perempuan" },
                { label: "Laki-laki" },
                { label: "Perempuan" },
                { label: "Laki-laki" },
                { label: "Perempuan" },
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["a", "b", "c", "d", "e", "f"],
            sumColumns: ["a", "b", "c", "d", "e", "f"],
            showTotal: true,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: true,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                title:
                  "Jumlah Penduduk Usia 7 s.d. 18 Tahun yang Belum Menyelesaikan Pendidikan Dasar dan Menengah",
                cols: 12,
                subGroups: [
                  {
                    title: "Usia 7 s.d. 12 Tahun",
                    cols: 2,
                    fields: [
                      { key: "a", label: "Laki-laki", type: "number" },
                      { key: "b", label: "Perempuan", type: "number" },
                    ],
                  },
                  {
                    title: "Usia 13 s.d. 15 Tahun",
                    cols: 2,
                    fields: [
                      { key: "c", label: "Laki-laki", type: "number" },
                      { key: "d", label: "Perempuan", type: "number" },
                    ],
                  },
                  {
                    title: "Usia 16 s.d. 18 Tahun",
                    cols: 2,
                    fields: [
                      { key: "e", label: "Laki-laki", type: "number" },
                      { key: "f", label: "Perempuan", type: "number" },
                    ],
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const c = num(row.c);
            const d = num(row.d);
            const e = num(row.e);
            const f = num(row.f);

            return {
              ...row,
              a,
              b,
              c,
              d,
              e,
              f,
              total: a + b + c + d + e + f,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 7
      // =========================
      if (id === 7) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 3, width: "5%" },
                { label: "Kecamatan", rowspan: 3, width: "12%" },
                { label: "Kondisi Toilet", colspan: 6 },
                { label: "Ket", rowspan: 3, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 3, width: "7%" }] : []),
              ],
              [
                { label: "Kondisi Baik", colspan: 3 },
                {
                  label:
                    "Kondisi Tidak Baik (Rusak Berat, Rusak Sedang dan Rusak Ringan)",
                  colspan: 3,
                },
              ],
              [
                { label: "SD" },
                { label: "SMP" },
                { label: "Jumlah" },
                { label: "SD" },
                { label: "SMP" },
                { label: "Jumlah" },
              ],
            ],

            bodyColumns: ["a", "b", "total1", "c", "d", "total2"],
            sumColumns: ["a", "b", "c", "d"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: true,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                title: "Kondisi Toilet",
                cols: 12,
                subGroups: [
                  {
                    title: "Kondisi Baik",
                    cols: 6,
                    fields: [
                      { key: "a", label: "SD", type: "number" },
                      { key: "b", label: "SMP", type: "number" },
                    ],
                  },
                  {
                    title: "Kondisi Tidak Baik",
                    cols: 6,
                    fields: [
                      { key: "c", label: "SD", type: "number" },
                      { key: "d", label: "SMP", type: "number" },
                    ],
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const c = num(row.c);
            const d = num(row.d);

            return {
              ...row,
              a,
              b,
              c,
              d,
              total1: a + b,
              total2: c + d,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 8
      // =========================
      if (id === 8) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Kecamatan", rowspan: 2, width: "12%" },
                {
                  label: "Jenjang Pendidikan",
                  colspan: 2,
                },
                { label: "Jumlah", rowspan: 2, width: "15%" },
                { label: "Ket", rowspan: 2, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [{ label: "SD" }, { label: "SMP" }],
            ],

            bodyColumns: ["a", "b"],
            sumColumns: ["a", "b"],
            showTotal: true,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                title: "Jenjang Pendidikan",
                cols: 2,
                fields: [
                  { key: "a", label: "SD", type: "number" },
                  { key: "b", label: "SMP", type: "number" },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);

            return {
              ...row,
              a,
              b,
              total: a + b,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 9
      // =========================
      if (id === 9) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Jenjang Pendidikan", rowspan: 2, width: "12%" },
                { label: "Nama Sekolah", rowspan: 2, width: "12%" },
                { label: "Kec", rowspan: 2, width: "12%" },
                {
                  label: "Kondisi Toilet",
                  colspan: 2,
                },
                { label: "Jumlah", rowspan: 2, width: "15%" },
                { label: "Ket", rowspan: 2, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [{ label: "Kondisi Baik" }, { label: "Kondisi Tidak Baik" }],
            ],

            bodyColumns: ["a", "b"],
            sumColumns: ["a", "b"],
            showTotal: true,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                title: "Kondisi Toilet",
                cols: 2,
                fields: [
                  { key: "a", label: "Kondisi Baik", type: "number" },
                  { key: "b", label: "Kondisi Tidak Baik", type: "number" },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);

            return {
              ...row,
              a,
              b,
              total: a + b,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 10
      // =========================
      if (id === 10) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 3, width: "5%" },
                { label: "Kecamatan", rowspan: 3, width: "12%" },
                { label: "Kondisi Ruang Kelas", colspan: 6 },
                { label: "Ket", rowspan: 3, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 3, width: "7%" }] : []),
              ],
              [
                { label: "Kondisi Baik", colspan: 3 },
                {
                  label:
                    "Kondisi Tidak Baik (Rusak Berat, Rusak Sedang dan Rusak Ringan)",
                  colspan: 3,
                },
              ],
              [
                { label: "SD" },
                { label: "SMP" },
                { label: "Jumlah" },
                { label: "SD" },
                { label: "SMP" },
                { label: "Jumlah" },
              ],
            ],

            bodyColumns: ["a", "b", "total1", "c", "d", "total2"],
            sumColumns: ["a", "b", "c", "d"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: true,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                title: "Kondisi Ruang Kelas",
                cols: 12,
                subGroups: [
                  {
                    title: "Kondisi Baik",
                    cols: 6,
                    fields: [
                      { key: "a", label: "SD", type: "number" },
                      { key: "b", label: "SMP", type: "number" },
                    ],
                  },
                  {
                    title: "Kondisi Tidak Baik",
                    cols: 6,
                    fields: [
                      { key: "c", label: "SD", type: "number" },
                      { key: "d", label: "SMP", type: "number" },
                    ],
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const c = num(row.c);
            const d = num(row.d);

            return {
              ...row,
              a,
              b,
              c,
              d,
              total1: a + b,
              total2: c + d,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 11
      // =========================
      if (id === 11) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Kecamatan", rowspan: 2, width: "12%" },
                {
                  label: "Jenjang Pendidikan",
                  colspan: 2,
                },
                { label: "Jumlah", rowspan: 2, width: "15%" },
                { label: "Ket", rowspan: 2, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [{ label: "SD" }, { label: "SMP" }],
            ],

            bodyColumns: ["a", "b"],
            sumColumns: ["a", "b"],
            showTotal: true,
            showKet: true,
            showAksi: !isCetak,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                title: "Jenjang Pendidikan",
                cols: 2,
                fields: [
                  { key: "a", label: "SD", type: "number" },
                  { key: "b", label: "SMP", type: "number" },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);

            return {
              ...row,
              a,
              b,
              total: a + b,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 12
      // =========================
      if (id === 12) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Jenjang Pendidikan", rowspan: 2, width: "12%" },
                { label: "Nama Sekolah", rowspan: 2, width: "12%" },
                { label: "Kec", rowspan: 2, width: "12%" },
                {
                  label: "Kondisi Ruang Kelas",
                  colspan: 2,
                },
                { label: "Jumlah", rowspan: 2, width: "15%" },
                { label: "Ket", rowspan: 2, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [{ label: "Kondisi Baik" }, { label: "Kondisi Kurang Baik" }],
            ],

            bodyColumns: ["a", "b"],
            sumColumns: ["a", "b"],
            showTotal: true,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                title: "Kondisi Ruang Kelas",
                cols: 2,
                fields: [
                  { key: "a", label: "Kondisi Baik", type: "number" },
                  { key: "b", label: "Kondisi Kurang Baik", type: "number" },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);

            return {
              ...row,
              a,
              b,
              total: a + b,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 13
      // =========================
      if (id === 13) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Bulan", rowspan: 2, width: "12%" },
                { label: "Pusat Peninggalan Bersejarah", colspan: 4 },
                { label: "Jumlah Total Kunjungan", rowspan: 2, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [
                { label: "Museum" }, 
                { label: "Cagar Budaya" },
                { label: "Monumen" },
                { label: "Kawasan Bersejarah" },
              ],
            ],

            bodyColumns: ["a", "b", "c", "d", "total"],
            sumColumns: ["a", "b", "c", "d", "total"],
            showTotal: false,
            showKet: false,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                title: "Pusat Peninggalan Bersejarah",
                cols: 4,
                fields: [
                  { key: "a", label: "Museum", type: "number" },
                  { key: "b", label: "Cagar Budaya", type: "number" },
                  { key: "c", label: "Monumen", type: "number" },
                  { key: "d", label: "Kawasan Bersejarah", type: "number" },
                ],
              },
            ],
            showKet: false,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const c = num(row.c);
            const d = num(row.d);

            return {
              ...row,
              a,
              b,
              c,
              d,
              total: a + b + c + d,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 14
      // =========================
      if (id === 14) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Bulan", rowspan: 2, width: "12%" },
                { label: "Pusat Peninggalan Bersejarah", colspan: 4 },
                { label: "Jumlah Total Kunjungan", rowspan: 2, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [
                { label: "Museum" }, 
                { label: "Cagar Budaya" },
                { label: "Monumen" },
                { label: "Kawasan Bersejarah" },
              ],
            ],

            bodyColumns: ["a", "b", "c", "d", "total"],
            sumColumns: ["a", "b", "c", "d", "total"],
            showTotal: false,
            showKet: false,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                title: "Pusat Peninggalan Bersejarah",
                cols: 4,
                fields: [
                  { key: "a", label: "Museum", type: "number" },
                  { key: "b", label: "Cagar Budaya", type: "number" },
                  { key: "c", label: "Monumen", type: "number" },
                  { key: "d", label: "Kawasan Bersejarah", type: "number" },
                ],
              },
            ],
            showKet: false,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const c = num(row.c);
            const d = num(row.d);

            return {
              ...row,
              a,
              b,
              c,
              d,
              total: a + b + c + d,
            };
          },
        };
      }

      // =========================
      // DEFAULT
      // =========================
      return {
        id,
        table: {
          headRows: [],
          bodyColumns: [],
          showTotal: false,
          showKet: false,
          showAksi: !isCetak,
        },
        form: {
          groups: [],
          showKet: false,
        },
        calcRow: (row) => row,
      };
    },

    // ini dipakai untuk table view
    normalizedRows() {
      return (this.list_data || []).map(this.indikatorSchema.calcRow);
    },

    // ini dipakai untuk cetak
    normalizedCetakRows() {
      return (this.cetak_data || []).map(this.indikatorSchema.calcRow);
    },
  },

  methods: {
    getCellValue(row, key) {
      return row[key] ?? 0;
    },
    getView: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_DIKBUD + "viewSekolah", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value,
          tahun: this.form.tahun.id,
          indikator: this.form.indikator.id,
        }),
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log("dasf");

          console.log(res_data);
          console.log("dasf");
          this.list_data = res_data.data;
          this.cetak_data = res_data.cetak;
          this.page_last = res_data.jml_data;
          this.$store.commit("hideLoading");
          this.nama_tahun = res_data.data[0].thn;
          this.indikator = res_data.data[0].indikator;
        });
    },

    getTotal: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_TOTAL + "dikbudSekolah", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify({
          tahun: this.form.tahun.id,
          indikator: this.form.indikator.id,
        }),
      })
        .then((res) => res.json())
        .then((res_data) => {
          this.$store.commit("hideLoading");
          this.total1 = res_data.data[0].total1;
          this.total2 = res_data.data[0].total2;
          this.total3 = res_data.data[0].total3;
          this.total4 = res_data.data[0].total4;
          this.total5 = res_data.data[0].total5;
          this.total6 = res_data.data[0].total6;
          this.total7 = res_data.data[0].total7;
          this.total8 = res_data.data[0].total8;
          console.log(res_data);
        });
    },

    getKadis: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Unit + "kadis", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.nama_kadis = res_data[0].nama;
          this.nip_kadis = res_data[0].nip;
          this.pangkat_kadis = res_data[0].pangkat;
          this.gol_kadis = res_data[0].gol;
          this.ruang_kadis = res_data[0].ruang;
          this.gel_dep_kadis = res_data[0].gelar_depan;
          this.gel_bel_kadis = res_data[0].gelar_belakang;
          this.$store.commit("hideLoading");
        });
    },

    getKecamatan: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Kecamatan + "view", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.list_kecamatan = res_data;

          console.log(this.list_kecamatan);
          this.$store.commit("hideLoading");
        });
    },

    getTahun: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Tahun, {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.list_tahun = res_data;
          this.$store.commit("hideLoading");
        });
    },

    getIndikator: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_DIKBUD + "indikator_sekolah", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.list_indikator = res_data;
          this.$store.commit("hideLoading");
        });
    },
    printTable() {
      const printWindow = window.open("", "_blank");
      const content = document.getElementById("printCetak").innerHTML;

      const style = `
    <style>
      @page { margin: 10mm; }

      body {
        font-family: Arial, sans-serif;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        margin: 0;
        padding: 0;
      }

      table {
        width: 100%;
        border-collapse: collapse;
      }

      th, td {
        border: 1px solid #ddd;
        padding: 5px;
        font-size: 11px;
        word-break: break-word;
        white-space: normal;
      }

      .text-center {
        text-align: center !important;
      }

      .print-wrapper {
        transform-origin: top left;
        display: inline-block;
      }
    </style>
  `;

      printWindow.document.open();
      printWindow.document.write(`
    <html>
      <head>
        <title>Dinas Pendidikan & Kebudayaan</title>
        ${style}
      </head>
      <body>
        <div id="wrapper" class="print-wrapper">
          ${content}
        </div>
      </body>
    </html>
  `);
      printWindow.document.close();

      printWindow.onload = function () {
        const wrapper = printWindow.document.getElementById("wrapper");

        // lebar halaman yang sedang aktif (portrait/landscape ikut user)
        const pageWidth = printWindow.innerWidth;

        // lebar tabel / konten
        const contentWidth = wrapper.scrollWidth;

        if (contentWidth > pageWidth) {
          const scale = pageWidth / contentWidth;
          wrapper.style.transform = `scale(${scale})`;
        } else {
          wrapper.style.transform = "scale(1)";
        }

        printWindow.focus();
        printWindow.print();
      };
    },
    addData: function () {
      // var formData = new FormData();
      // formData.append('data', JSON.stringify(this.form))
      fetch(this.$store.state.url.URL_DIKBUD + "addSekolah", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify(this.form),
      }).then((res_data) => {
        this.Notify(
          "Sukses Menambah Data",
          "light-blue-4",
          "check_circle_outline",
        );
        console.log(res_data);
        this.getView();
      });
    },

    editData: function () {
      console.log(this.form);
      fetch(this.$store.state.url.URL_DIKBUD + "editSekolah", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify(this.form),
      }).then((res_data) => {
        this.Notify("Sukses Merubah Data", "lime-7", "check_circle_outline");
        this.getView();
      });
    },

    removeData: function (a) {
      fetch(this.$store.state.url.URL_DIKBUD + "removeSekolah", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify({ id: a }),
      }).then((res_data) => {
        this.Notify(
          "Sukses Menghapus Data",
          "deep-orange-10",
          "check_circle_outline",
        );
        this.getView();
      });
    },

    selectData: function (data) {
      this.form.id = data.id;
      this.form.jenjang = data.jenjang;
      this.form.sekolah = data.sekolah;
      this.form.a = data.a;
      this.form.b = data.b;
      this.form.c = data.c;
      this.form.d = data.d;
      this.form.e = data.e;
      this.form.f = data.f;
      this.form.g = data.g;
      this.form.h = data.h;
      this.form.keterangan = data.keterangan;
      this.form.createAt = data.createAt;
    },

    // ====================================== PAGINATE ====================================
    Notify: function (message, positive, icon) {
      this.$q.notify({
        message: message,
        color: positive,
        icon: icon,
        position: "top",
        timeout: 500,
      });
    },
    btn_prev: function () {
      this.cek_load_data = true;
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getView();
    },

    btn_next: function () {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getView();
    },

    cari_data: function () {
      this.page_first = 1;
      this.getView();
    },

    // ====================================== PAGINATE ====================================
  },

  mounted() {
    this.getView();
    this.getTahun();
    this.getKadis();
    this.getIndikator();
    this.getKecamatan();
  },
};
